export const isMobile = () => window.innerWidth < 767;
export const isMobileDevice = /iPad|iPhone|iPod|tablet|Android|Mobile/.test(
    window.navigator.userAgent
);
